import { observable } from 'mobx';
import { ButtonType, ButtonWidgetProps } from '../../widgets/controls/ButtonWidget';

export interface Dialog {
  title: string;
  desc: string;
  btns: ButtonWidgetProps[];
}

export class DialogStore {
  @observable
  accessor dialog: Dialog;

  constructor() {
    this.dialog = null;
  }

  async showConfirmDialog(dialog: Omit<Dialog, 'btns'>): Promise<boolean> {
    return await new Promise<boolean>((resolve) => {
      this.showDialog({
        ...dialog,
        btns: [
          {
            label: 'Yes',
            action: () => {
              resolve(true);
            }
          },
          {
            label: 'No',
            type: ButtonType.SECONDARY,
            action: () => {
              resolve(false);
            }
          }
        ]
      });
    });
  }

  showDialog(dialog: Dialog) {
    this.dialog = {
      ...dialog,
      btns: dialog.btns.map((btn) => {
        return {
          ...btn,
          action: () => {
            this.dialog = null;
            btn.action();
          }
        };
      })
    };
  }
}
